import React from 'react';
import { FadeIn } from '../../../ui/Transitions';
import { HideIfHasFeature } from '../../common/FeatureElements';
import { useResolve } from '../../Container';
import { CollaborateProductTip, ProductTip, WatchProductTip } from '../home/ProductTips';
import { WorkspaceModel } from '../Models';

export const TeamProductTips = () => {

    const workspace = useResolve(WorkspaceModel);
    if (workspace.type !== 'team') return null;

    return <HideIfHasFeature name="readonly">
        <FadeIn>
            <ProductTip.Wrapper>
                <WatchProductTip />
                {/* <LearnProductTip /> */}
                {/* <HelpProductTip /> */}
                <CollaborateProductTip />
            </ProductTip.Wrapper>
        </FadeIn>
    </HideIfHasFeature>;
};
